import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SocialMediaShare } from '../Share/SocialMediaShare';

export const Footer: React.FC = () => {
  const { t } = useTranslation();
  const websiteUrl = 'https://iptvplayer.stream';
  const shareTitle = t('share.title', 'Check out this awesome IPTV Player!');
  const shareDescription = t('share.description', 'A web-based IPTV player that lets you watch and manage your M3U playlists with ease.');

  return (
    <footer className="bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 overflow-x-hidden">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and Description */}
          <div className="space-y-4">
            <h3 className="text-lg font-bold text-gray-900 dark:text-white">
              {t('common.appName', 'IPTVPlayer.stream')}
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              {t('common.description', 'A modern, user-friendly IPTV player for your streaming needs.')}
            </p>
            {/* Social Media Share */}
            <div className="pt-4">
              <h4 className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-3">
                {t('share.withFriends', 'Share with friends')}
              </h4>
              <SocialMediaShare
                url={websiteUrl}
                title={shareTitle}
                description={shareDescription}
              />
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="text-lg font-bold text-gray-900 dark:text-white">
              {t('footer.quickLinks', 'Quick Links')}
            </h3>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/free-m3u-hls-playlists"
                  className="text-sm text-gray-600 dark:text-gray-400 hover:text-primary dark:hover:text-primary transition-colors cursor-pointer"
                >
                  {t('footer.freeSources', 'Free IPTV Sources')}
                </Link>
              </li>
              <li>
                <Link 
                  to="/m3u-hls-player-features"
                  className="text-sm text-gray-600 dark:text-gray-400 hover:text-primary dark:hover:text-primary transition-colors cursor-pointer"
                >
                  {t('footer.features', 'Features Guide')}
                </Link>
              </li>
              <li>
                <Link 
                  to="/m3u-hls-player-playlist-sharing"
                  className="text-sm text-gray-600 dark:text-gray-400 hover:text-primary dark:hover:text-primary transition-colors cursor-pointer"
                >
                  {t('footer.sharing', 'Sharing Guide')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Support Section */}
          <div className="space-y-4">
            <h3 className="text-lg font-bold text-gray-900 dark:text-white">
              {t('footer.support', 'Support')}
            </h3>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/m3u-hls-player-faq"
                  className="text-sm text-gray-600 dark:text-gray-400 hover:text-primary dark:hover:text-primary transition-colors cursor-pointer"
                >
                  {t('footer.faq', 'FAQ')}
                </Link>
              </li>
              <li>
                <Link 
                  to="/contact"
                  className="text-sm text-gray-600 dark:text-gray-400 hover:text-primary dark:hover:text-primary transition-colors cursor-pointer"
                >
                  {t('footer.contact', 'Contact Us')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal Links */}
          <div className="space-y-4">
            <h3 className="text-lg font-bold text-gray-900 dark:text-white">
              {t('footer.legal', 'Legal')}
            </h3>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/privacy"
                  className="text-sm text-gray-600 dark:text-gray-400 hover:text-primary dark:hover:text-primary transition-colors"
                >
                  {t('footer.privacy', 'Privacy Policy')}
                </Link>
              </li>
              <li>
                <Link 
                  to="/terms"
                  className="text-sm text-gray-600 dark:text-gray-400 hover:text-primary dark:hover:text-primary transition-colors"
                >
                  {t('footer.terms', 'Terms of Service')}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-8 border-t border-gray-200 dark:border-gray-700 text-center">
          <p className="text-sm text-gray-600 dark:text-gray-400">
            {t('footer.copyright', '© {{year}} IPTVPlayer.stream. All rights reserved.', {
              year: new Date().getFullYear()
            })}
          </p>
        </div>
      </div>
    </footer>
  );
}; 